<template>
  <div class="dashboard" id="single-site-dashboard">

     <div v-if="isLoading" class="loading-screen">
      <div class="loading-container">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </div>
    <template v-else>
      <!-- LEFT COLUMN -->
      <div v-if="dataSingleSite" class="column column-left">

        <!-- Site Summary -->
        <section class="card primary-card">
          <div class="primary-header">
            <div class="logo-title">
              <div class="logo">TOYOTA</div>
              <div>
                <h2 class="site-name">{{ dataSingleSite.site_name ? dataSingleSite.site_name : '' }}</h2>
                <p class="site-subtitle">Energy overview</p>
              </div>
            </div>

            <select v-model="selectedPeriod" class="select">
              <option value="month">Month</option>
              <option value="week">Week</option>
              <option value="day">Day</option>
            </select>
          </div>

          <!-- 3 small metrics -->
          <div class="primary-metrics">
            <div class="metric">
              <span class="metric-label">Estimated Monthly Cost</span>
              <span class="metric-value">200,123</span>
              <span class="metric-unit">Baht</span>
            </div>
            <div class="metric">
              <span class="metric-label">Average Cost</span>
              <span class="metric-value">540</span>
              <span class="metric-unit">Baht/hr</span>
            </div>
            <div class="metric">
              <span class="metric-label">Zone Temperature</span>
              <span class="metric-value">29</span>
              <span class="metric-unit">°C</span>
            </div>
          </div>

          <!-- Usage → bar chart + pie chart -->
          <div class="primary-body">
            <div class="usage-chart">
              <canvas ref="usageBarRef"></canvas>
            </div>

            <div class="usage-pie">
              <div class="pie-wrapper">
                <canvas ref="usagePieRef"></canvas>
                <div class="pie-center">
                  <div class="pie-total">3,690</div>
                  <div class="pie-label">kWh total usage</div>
                </div>
              </div>

              <ul class="legend">
                <li>
                  <span class="dot dot-solar"></span>
                  Solar <span>0 kWh</span>
                </li>
                <li>
                  <span class="dot dot-grid"></span>
                  Grid <span>2,277 kWh</span>
                </li>
                <li>
                  <span class="dot dot-battery"></span>
                  Battery <span>0 kWh</span>
                </li>
              </ul>
            </div>

          </div>
        </section>

        <!-- Energy usage per group -->
        <section class="card">
          <h3>Energy usage per group</h3>

          <div class="group-list">
            <div class="group-row" v-for="g in groupUsage" :key="g.name">
              <div class="group-name">{{ g.name }}</div>
              <div class="group-bar">
                <div class="bar-bg">
                  <div class="bar-fill" :style="{ width: g.percent + '%' }"></div>
                </div>
                <span class="group-percent">{{ g.percent }}%</span>
                <span class="group-energy">{{ g.energy }} kWh</span>
              </div>
            </div>
          </div>
        </section>

      </div>

      <!-- MIDDLE COLUMN -->
      <div v-if="dataSingleSite" class="column column-middle">
        <!-- Energy Input Output -->
        <section class="card">
          <h3>Energy input & output</h3>

          <div class="io-grid">
            <div class="io-box">
              <p class="io-label">Solar</p>
              <p class="io-value">{{ dataSingleSite.iot_data.pv_power.life_time ? dataSingleSite.iot_data.pv_power.life_time : '0' }} kW</p> 
            </div>

            <div class="io-box">
              <p class="io-label">Battery</p>
              <p class="io-value">{{ dataSingleSite.iot_data.pv_power.life_time ? dataSingleSite.iot_data.bess_power.life_time : '0' }} kW</p>
            </div>

            <div class="io-box">
              <p class="io-label">Power grid</p>
              <p class="io-value">{{ dataSingleSite.iot_data.pv_power.life_time ? dataSingleSite.iot_data.grid_power.life_time : '0' }} kW</p>
            </div>

            <div class="building-box">
              <div class="building">[ Building Illustration ]</div>
            </div>

            <div class="io-box">
              <p class="io-label">Usage</p>
              <p class="io-value">20.78 kW</p>
            </div>
            <div class="io-box">
              <p class="io-label">Export</p>
              <p class="io-value">20.78 kW</p>
            </div>
          </div>
        </section>

        <!-- Timeline chart -->
        <section class="card">
          <div class="timeline-header">
            <h3>Group supply / consumption</h3>

            <div>
              <select v-model="selectedGroup" class="select small">
                <option>Building 1</option>
                <option>B1, Level 7</option>
              </select>
              <select v-model="selectedRange" class="select small">
                <option>Day</option>
                <option>Week</option>
              </select>
            </div>
          </div>

          <canvas ref="timelineRef"></canvas>
        </section>
      </div>

      <!-- RIGHT COLUMN -->
      <div v-if="dataSingleSite" class="column column-right">

        <!-- Solar panel -->
        <section class="card">
          <h3>Solar panel status</h3>
          <div>Realtime yield: <b>5.3 kW</b></div>
          <div>Total yield today: 32.5 kWh</div>
          <div>Lifetime yield: 520.8 kWh</div>
        </section>

        <!-- Battery -->
        <section class="card">
          <h3>Battery status</h3>
          <div>Voltage: 52.3 V</div>
          <div>Current: 16 A</div>
          <div>Temperature: 32 °C</div>
          <div>Power: -1.2 kW (discharging)</div>
          <div>Daily charging: 120 kWh</div>
          <div>Monthly charging: 17.2 mWh</div>
          <div>Cumulative: 500.2 mWh</div>
        </section>

      </div>
    </template>
  </div>
</template>

<script>
import Chart from "chart.js/auto"

export default {
  name: "DataIoTDashboard",

  data() {
    return {

      groupList: [
        "Building 1",
        "B1, Level 7",
        "Warehouse",
        "Parking Area",
        "Office Zone A"
      ],
      isLoading: false,
      dataSingleSite: {
        id: 157,
        site_name: "Toyota Kohn Kaen Head Office",
        status: "normal",
        address: "Moo 7, Tambon Khlong Song, Amphoe Khlong Luang, Chang Wat Pathum Thani 12120",
        latitude: 14.05997540,
        longitude: 100.65060830,
        created_at: "2024-03-20 23:21:33",
        iot_data: {
          pv_power: {
            daily: 1.4,
            monthly: 2.4,
            life_time: 12,
          },
          grid_power: {
            daily: 1.12,
            monthly: 2.43,
            life_time: 23
          },
          bess_power: {
            daily: 0,
            monthtly: 0,
            life_time: 0
          }
        }
      },

      /* -----------------------
      SELECT STATE
      ------------------------ */
      selectedPeriod: "day",
      selectedGroup: "Building 1",
      selectedRange: "day",
      /* -----------------------
          SAMPLE DATA FOR PERIODS
      ------------------------ */

      usageData: {
        day:   [12, 20, 32, 50, 80, 120, 110, 95, 70, 40],
        week:  [220, 260, 310, 400, 520, 610, 580],
        month: [800, 920, 760, 1000, 1200, 1300, 1100, 900]
      },
      usageLabels: {
        day:   ["0h","2h","4h","6h","8h","10h","12h","14h","16h","18h","19h", "20h", "22h", "23h59"],
        week:  ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"],
        month: ["W1","W2","W3","W4","W5"]
      },

        /* -----------------------
            GROUP ENERGY SAMPLE
        ------------------------ */
      groupUsage: [
        { name: "Building 1",     percent: 60, energy: 300 },
        { name: "B1, Level 7",    percent: 15, energy: 80 },
        { name: "B1, Level 6",    percent: 15, energy: 80 },
        { name: "B1, Level 5",    percent: 8,  energy: 50 },
        { name: "B1, Level 4",    percent: 5,  energy: 20 },
        { name: "B1, Level 2",    percent: 2,  energy: 8  },
      ],

      /* -----------------------
        CHART REFS
      ------------------------ */
      usageBarRef: null,
      usagePieRef: null,
      timelineRef: null,
      usageChart: null,
      pieChart: null,
      timelineChart: null,


      timelineDataset: {
        day: {
          labels: ["0h","2h","4h","6h","8h","10h","12h","14h","16h","18h"],
          grid:    [20,25,30,22,18,15,20,28,30,25],
          solar:   [0,0,10,25,40,55,60,45,20,0],
          battery: [-5,-3,0,6,12,8,3,-1,-4,-6]
        },
        week: {
          labels: ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"],
          grid:    [100,120,140,160,180,160,150],
          solar:   [20,40,60,80,70,40,30],
          battery: [-20,-10,-5,10,8,-3,-8]
        }
      }
    };
  },

  /* -----------------------
      INIT CHARTS
  ------------------------ */
  mounted() {
    this.createUsageBarChart()
    this.createUsagePieChart()
    this.createTimelineChart()
  },

  /* -----------------------
      RE-RENDER WHEN SELECT CHANGES
  ------------------------ */
  watch: {
    selectedPeriod() {
      this.updateUsageBarChart();
    },
    selectedRange() {
      this.updateTimelineChart();
    }
  },

  /* -----------------------
      USAGE BAR CHART
  ------------------------ */
  methods: {
    createUsageBarChart() {
      this.usageChart = new Chart(this.usageBarRef.value, {
        type: "bar",
        data: {
          labels: this.usageLabels[this.selectedPeriod.value],
          datasets: [
            {
              data: this.usageData[this.selectedPeriod.value],
              backgroundColor: "#2563eb",
              borderRadius: 6,
            }
          ]
        },
        options: {
          plugins: { legend: { display: false }},
          scales: {
            x: { grid: { display: false }},
            y: { ticks: { callback: v => v + " kWh" }}
          }
        }
      })
    },
    updateUsageBarChart() {
      this.usageChart.data.labels = this.usageLabels[this.selectedPeriod.value]
      this.usageChart.data.datasets[0].data = this.usageData[this.selectedPeriod.value]
      this.usageChart.update()
    },

    createUsagePieChart() {
      this.pieChart = new Chart(this.usagePieRef.value, {
        type: "doughnut",
        data: {
          labels: ["Solar", "Grid", "Battery"],
          datasets: [
            {
              data: [1412, 2277, 0],
              backgroundColor: ["#22c55e", "#3b82f6", "#f97316"],
              cutout: "70%"
            }
          ]
        },
        options: { plugins: { legend: { display: false }}}
      })
    },

    createTimelineChart() {
      this.timelineChart = new Chart(this.timelineRef.value, {
        type: "line",
        data: {
          labels: this.timelineDataset[this.selectedRange].labels,
          datasets: [
            { label: "Grid",    data: this.timelineDataset.day.grid,    borderColor: "#2563eb", tension: 0.4 },
            { label: "Solar",   data: this.timelineDataset.day.solar,   borderColor: "#22c55e", tension: 0.4 },
            { label: "Battery", data: this.timelineDataset.day.battery, borderColor: "#f97316", tension: 0.4 }
          ]
        }
      })
    },

    updateTimelineChart() {
      const d = this.timelineDataset[this.selectedRange]
      this.timelineChart.data.labels = d.labels
      this.timelineChart.data.datasets[0].data = d.grid
      this.timelineChart.data.datasets[1].data = d.solar
      this.timelineChart.data.datasets[2].data = d.battery
      this.timelineChart.update()
    }
  }
};




</script>


<style scoped>
/* Basic clean modern UI */
.dashboard {
  display: grid;
  grid-template-columns: 1.3fr 1.4fr 1fr;
  gap: 20px;
  padding: 16px;
  font-family: 'Inter', sans-serif;
}

.card {
  background: white;
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.06);
}

.column {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* LEFT */
.primary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-weight: 700;
  color: #dc2626;
}

.site-name {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.select {
  padding: 6px 12px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.primary-metrics {
  display: flex;
  gap: 16px;
  margin: 16px 0;
}

.metric-label {
  font-size: 11px;
  color: #6b7280;
}

.metric-value {
  font-size: 20px;
  font-weight: 700;
}

.primary-body {
  display: grid;
  grid-template-columns: 2fr 1.5fr;
  gap: 20px;
}

/* Pie chart center */
.pie-wrapper {
  position: relative;
  width: 140px;
  height: 140px;
}

.pie-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.pie-total {
  font-weight: 700;
  font-size: 16px;
}

/* Group list */
.group-row {
  display: grid;
  grid-template-columns: 1fr 3fr;
  font-size: 12px;
}

.group-bar {
  display: flex;
  align-items: center;
  gap: 6px;
}

.bar-bg {
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 8px;
}

.bar-fill {
  height: 8px;
  background: #3b82f6;
  border-radius: 8px;
}

/* MIDDLE */
.io-grid {
  display: grid;
  grid-template-columns: repeat(3,1fr);
  gap: 12px;
  text-align: center;
}

.io-label {
  font-size: 12px;
  color: #6b7280;
}

.io-value {
  font-size: 16px;
  font-weight: 600;
}

.building {
  height: 100px;
  background: #f3f4f6;
  border: 1px dashed #d1d5db;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* RIGHT */
.card h3 {
  margin-bottom: 12px;
}
</style>
